import { durationPatterns, startTimePatterns } from '../constants';

export default class Time {

    static checkForm (className) {
        let duration = this.state.duration,
            startTime = this.state.startTime,
            taskID = this.refs.taskInput.getSelectedId();

        // TODO: validate input, show error messages
        let errors = [];

        if (isNaN(duration)) duration = 0;

        if (className === "EditModal") {
            if (duration > 1200) errors.push({ input: "duration", message: "Duration cannot exceed 20 hours" });
        }
        if (className === "EditPopover") {
            if (duration > 1440) errors.push({ input: "duration", message: "Duration cannot exceed 24 hours" });
        }
        if (className === "NewWorkLogWiget") {
            if (taskID === null) errors.push({ input: "task", message: "A task must be selected" });
            if (duration > 1200) errors.push({ input: "duration", message: "Duration cannot exceed 20 hours" });
        }

        if (duration < 0) errors.push({ input: "duration", message: "Duration cannot be negative" });

        if (startTime && startTime.length > 0) {
            let startTimeValidation = new RegExp(/^([0-9]?|1[0-9]|2[0-3]|0[0-9]):[0-5][0-9]$/);

            if (!startTimeValidation.test(startTime)) {
                errors.push({ input: "startTime", message: "Start time must be in HH:mm format" });
            }
        }

        this.setState({
            errors: errors
        });
    }

    static convertStartTime (event) {
        let hm = Time.parseStartTime(event.target.value.trim());

        this.setState({
            startTime: hm !== null ? this.startTimeFormat(hm[0], hm[1]) : ""
        }, this.checkForm);
    }

    static convertToStandardForm (event) {
        let hm = this.parseDuration(event.target.value.trim());

        this.setState({
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? this.durationFormat(hm[0], hm[1]) : "",
            elementFocused: false
        });
    }

    static decrementDate () {
        this.state.date.subtract(1, 'day');

        this.setState({
            date: this.state.date
        });
    }

    static durationFormat (h, m) {
        if (parseInt(m) < 10) return h + ":0" + m;
        else return h + ":" + m;
    }

    static hours (a) {
        return [a[1], 0, parseInt(a[1]) * 60];
    }

    static hoursdec (a) {
        return [a[1], Math.round(parseFloat("0." + a[2]) * 60), parseInt(a[1]) * 60 + Math.round(parseFloat("0." + a[2]) * 60)];
    }

    static hoursmins (a) {
        return [a[1], parseInt(a[2]), parseInt(parseInt(a[1]) * 60 + parseInt(a[2]))];
    }

    static incrementDate () {
        this.state.date.add(1, 'day');

        this.setState({
            date: this.state.date
        });
    }

    static mins (a)  {
        return [Math.floor(a[1] / 60), a[1] % 60, parseInt(a[1])];
    }

    static parseDuration (s) {
        let patternProcessors = [this.hours, this.mins, this.hours, this.mins, this.hoursdec, this.hoursmins];
        let matcher = null;
        let n = 0;
        for (n = 0; n < durationPatterns.length; n++) {
            matcher = s.match(durationPatterns[n]);
            if (matcher !== null) break;
        }

        if (matcher === null) return null;
        else return patternProcessors[n](matcher);
    }

    static parseStartTime (s) {
        let patternProcessors = [this.hours, this.hours, this.hoursmins];
        let matcher = null;
        let n = 0;
        for (n = 0; n < startTimePatterns.length; n++) {
            matcher = s.match(startTimePatterns[n]);
            if (matcher !== null) break;
        }

        if (matcher === null) return null;
        else return patternProcessors[n](matcher);
    }

    static startTimeFormat (h, m) {
        if (parseInt(m) < 10) return h + ":0" + m;
        else return h + ":" + m;
    }

    // Solves problem of problematic weeks in which the year of first day of the week is different from the year of the
    // last day of the week. In that case, week number will equal to 53 instead of 1, since that is the way backend
    // stores that type of week.
    static getWeek(date) {
        return date.year() !== date.clone().add(6, 'days').year() && date.isoWeek() !== 52 ? 53 : date.isoWeek();
    }

    // Preprends "0" to week number if week number is lesser than 10, returns a string.
    static getFormattedWeek(date) {
        let week = Time.getWeek(date);
        return (week < 10 ? "0" : "") + week;
    }

    // Returns year and week formatted as "YYYYWW", where "WW" is determined by getFormattedWeek method.
    static getFormattedYearAndWeek(date) {
        let week = Time.getFormattedWeek(date);
        return date.year() + week;
    }

  static getISOWeeks(year) {
    let d = new Date(year, 0, 1);
    let isLeap = new Date(year, 1, 29).getMonth() === 1;
    return d.getDay() === 4 || isLeap && d.getDay() === 3 ? 53 : 52;
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/utils/time.js
 **/